// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"16":"d83ad269","248":"07f4e048","613":"07f4e048"}[chunkId] + ".css";
};